import React from 'react';
import { element } from 'prop-types';
import { Container } from 'semantic-ui-react';

import Navigation from './Navigation';

const PageWrap = props => (
  <div>
    <Navigation />
    <Container id="content" style={{ marginTop: '7em' }}>
      {props.children}
    </Container>
  </div>
);

PageWrap.propTypes = {
  children: element.isRequired,
};

export default PageWrap;



// WEBPACK FOOTER //
// ./src/components/PageWrap.jsx